export default __webpack_public_path__ + "img/aecda45439a1b5d37b2764e7c99f68de.svg";